import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from 'components/SearchBar/images/white-search.svg';

const styles = {
  inputContainer: {
    background: '#ffffff',
    color: '#000',
    border: '1px solid #CFD2D3',
    borderRadius: 3,
    width: '100%',
    height: props => props.height || 40,
  },
  inputRoot: {
    height: '100%',
  },
  search: {
    width: '100%',
  },
  iconContainer: {
    background: '#01619B',
    maxHeight: 'none',
    height: 'calc(100% + 2px)',
    marginRight: -1,
    width: 52,
    borderTopRightRadius: 3,
    borderBottomRightRadius: 3,
    display: 'flex',
    justifyContent: 'center',
  },
  input: {
    paddingLeft: 20,
    fontSize: 14,
  },
  progress: {
    height: '20px !important',
    width: '20px !important',
    color: '#FFFFFF',
  },
  icon: {
    height: 23,
    width: 22,
  },
};

class SearchBox extends React.PureComponent {
  constructor(props) {
    super(props);

    const { query } = props;
    this.state = {
      query,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { query } = this.props;
    const { query: nextQuery } = nextProps;

    if (query !== nextQuery) {
      this.props.onQueryChange(nextQuery);
      this.setState({ query: nextQuery });
    }
  }

  handleQueryChange = e => {
    clearTimeout(this.debouncedSetState);
    const query = e.target.value;
    this.setState({ query });

    this.debouncedSetState = setTimeout(() => {
      this.props.onQueryChange(query);
    }, 800);
  };

  render() {
    const { processing, classes, placeholder } = this.props;
    const { query } = this.state;

    return (
      <div className={classes.search}>
        <TextField
          placeholder={placeholder || 'Search'}
          value={query}
          onChange={this.handleQueryChange}
          classes={{ root: classes.inputContainer }}
          InputProps={{
            disableUnderline: true,
            classes: { root: classes.inputRoot, input: classes.input },
            endAdornment: (
              <InputAdornment position="end" className={classes.iconContainer}>
                {processing ? (
                  <CircularProgress classes={{ root: classes.progress }} />
                ) : (
                  <img src={SearchIcon} alt="Search" className={classes.icon} />
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  }
}

SearchBox.propTypes = {
  query: PropTypes.string,
  processing: PropTypes.bool,
  onQueryChange: PropTypes.func,
  classes: PropTypes.object,
  placeholder: PropTypes.string,
};

export default withStyles(styles)(SearchBox);
